import { createAction, props } from '@ngrx/store';
import { Tab } from '../../modules/main/enums/tab.enum';

export const SET_ACTIVE_TAB = '[TAB] SET_ACTIVE_TAB';

export const setActiveTabAction = createAction(SET_ACTIVE_TAB, props<{ payload: { tab: Tab } }>());
